import React from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';

// Updated interface to expect an array of string tuples with an optional third element for tooltip
interface PlanFeatures {
  [category: string]: Array<[string, string | undefined, string | undefined]>;
}

interface PricingCardProps {
  title: string;
  description: string;
  price: string;
  priceFrequency: string;
  yearlyPrice: string;
  features: PlanFeatures; // Now uses the updated interface
  buttonLabel: string;
  buttonClass?: string;
  highlight?: boolean; // To indicate the popular plan
  // The renderFeatures function should also accept the updated PlanFeatures type
  renderFeatures: (features: PlanFeatures) => JSX.Element;
}

const PricingCard: React.FC<PricingCardProps> = ({
  title,
  description,
  price,
  priceFrequency,
  yearlyPrice,
  features,
  buttonLabel,
  buttonClass = 'p-button-secondary',
  highlight = false,
  renderFeatures,
}) => {
  const cardClassName = `flex flex-column h-100 surface-card shadow-2 border-round ${highlight ? 'shadow-4 border-2 border-primary' : ''}`;

  return (
    <div className="col-12 md:col-4 px-3 mb-4">
      <Card title={title} className={cardClassName}>
        {highlight && (
          <div className="text-center mb-3">
            <span className="text-primary font-bold">Most Popular</span>
          </div>
        )}
        <p className="text-secondary mb-3 pb-3 border-bottom-1 surface-border">{description}</p>
        <div className="mb-3">
          <div className="text-2xl font-bold text-900">{price}<span className="text-base font-normal text-color-secondary">{priceFrequency}</span></div>
          <div className="text-color-secondary">{yearlyPrice}</div>
        </div>
        <div className="flex-grow-1 text-left">
          {/* renderFeatures function already handles the new data structure */}
          {renderFeatures(features)}
        </div>
        <div className="mt-auto pt-3 border-top-1 surface-border">
          <Button label={buttonLabel} className={`${buttonClass} mt-3`} />
        </div>
      </Card>
    </div>
  );
};

export default PricingCard;